import React, { useState, useEffect, useMemo, useRef, useCallback } from "react";
import {
  getUserListFromDb,
  clearUserListState,
} from "../redux/slices/getUserListSlice";
import { setEditUserData } from "../redux/slices/editUserDataSlice";
import { useSelector, useDispatch } from "react-redux";
import { setShowMessage } from "../redux/slices/notificationSlice";
import AlertDeleteModal from "./AlertDelete/AlertDeleteModal";
import Checkbox from "@mui/material/Checkbox";
import { Tooltip } from "@mui/material";
import edit from "../assets/images/editu.png";
import { Button } from "react-bootstrap";
import PersistentDataGrid from "../components/table/PersistentDataGrid";
import { GridToolbar } from "@mui/x-data-grid";
import Axios from "axios";
import translations from "../assets/locals/translations";
import "../styles/Users.css";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

export default function CallReportInDetails() {
  const [task, setTask] = useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userListState = useSelector(
    (state) => state.getUserListSlice.userListState
  );
  const [selectAll, setSelectAll] = useState(false);
  const [rowData, setRowData] = useState([]);
  const currentLanguage = useSelector((state) => state.language.language);

  // Column visibility state
  const [callReportInDetailsColumnShowHideModel, setCallReportInDetailsColumnShowHideModel] = useState({});
  const handleCallReportInDetailsColumnShowHideChange = (newModel) => {
    setCallReportInDetailsColumnShowHideModel(newModel);
    localStorage.setItem('callReportInDetails_columnShowHide', JSON.stringify(newModel));
  };

  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem('callReportInDetails_columnShowHide'));
    if (saved) {
      setCallReportInDetailsColumnShowHideModel(saved);
    }
  }, []);

  const handleHeaderCheckboxClick = () => {
    console.log(!selectAll, "selectAll");
    setSelectAll(!selectAll);
  };

  async function getIncompleteCallReport() {
    const url = `${process.env.REACT_APP_NODE_URL}/api/get_incomplete_call_task_report_details`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    await Axios.get(url, config).then((response) => {
      if (response.data) {
        if (response.data.isSuccess) {
          console.log("ehshd", response.data.result);
          setTask(response.data.result);
        }
      }
    });
  }
  useEffect(() => {
    getIncompleteCallReport();
  }, []);
  const handleChildCheckboxClick = (itemId) => {
    const updatedRowsData = rowData.map((row) => {
      if (row.id === itemId) {
        return {
          ...row,
          checkbox: !row.checkbox,
        };
      }
      return row;
    });
    console.log(updatedRowsData, "updatedRowsData");
    setRowData(updatedRowsData);
  };

  const formatDate = (startdate) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(startdate).toLocaleDateString(undefined, options);
  };

  const handleIncompleteCallDetails = (data) => {
    console.log(data, "dtasKdk")
    // navigate("/management/mytask/task-detail", {
    //   state: { taskdata: data },
    // });
  };

  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const columns = [
    {
      field: "rowNumber",
      headerName: (
        <Checkbox
          {...label}
          checked={selectAll}
          onClick={handleHeaderCheckboxClick}
        />
      ),
      minWidth: 90,
      renderCell: (params) => (
        <Checkbox
          {...label}
          checked={params.row.checkbox}
          onClick={() => handleChildCheckboxClick(params.row.id)}
        />
      ),
    },
    {
      field: "employee",
      headerAlign: "center",
      align: "center",
      headerClassName: "custom-header",
      headerName: translations[currentLanguage].employee,
      minWidth: 200,
      flex: 1,
      valueGetter: (params) => {
        return `${params.row.employee ? params.row.employee : "-"}`;
      },
    },
    {
      field: "tasktype_name",
      headerAlign: "left",
      align: "left",
      headerClassName: "custom-header",
      headerName: translations[currentLanguage].tasktype,
      minWidth: 200,
      flex: 1,
      valueGetter: (params) => {
        return `${params.row.tasktype_name ? params.row.tasktype_name : "-"}`;
      },
    },
    {
      field: "task_name",
      headerAlign: "left",
      align: "left",
      headerClassName: "custom-header",
      headerName: translations[currentLanguage].task,
      minWidth: 200,
      flex: 1.2,
      valueGetter: (params) => {
        return `${params.row.task_name ? params.row.task_name : "-"}`;
      },
    },
    {
      field: "incomplete_call_due",
      headerAlign: "left",
      align: "left",
      headerClassName: "custom-header",
      headerName: 'Incomplete Call Due To',
      minWidth: 200,
      flex: 1.2,
      valueGetter: (params) => {
        return `${params.row.incomplete_call_due ? params.row.incomplete_call_due : "-"}`;
      }
    },

    // {
    //     field: "incomplete_task",
    //     headerAlign: "left",
    //     align: "left",
    //     headerClassName: "custom-header",
    //     headerName: 'Incomplete Call',
    //     minWidth: 200,
    //     flex: 1.2,
    //     renderCell: (params) => (
    //       <button
    //         className="border-0 rounded p-2"
    //         onClick={() => handleIncompleteCallDetails(params.row)}
    //       >
    //         {`${params.row.incomplete_task ? params.row.incomplete_task : 0}/${
    //           params.row.taskcount ? params.row.taskcount : "-"
    //         }`}
    //       </button>
    //     ),
    //   },
    {
      field: "startdate",
      headerAlign: "left",
      align: "left",
      headerClassName: "custom-header",
      headerName: translations[currentLanguage].startd,
      minWidth: 200,
      flex: 1.2,
      valueGetter: (params) => formatDate(params.row.startdate),
    },
    {
      field: "enddate",
      headerAlign: "left",
      align: "left",
      headerClassName: "custom-header",
      headerName: translations[currentLanguage].endd,
      minWidth: 200,
      flex: 1.2,
      valueGetter: (params) => formatDate(params.row.enddate),
    },
    {
      field: "period_name",
      headerAlign: "left",
      align: "left",
      headerClassName: "custom-header",
      headerName: translations[currentLanguage].tasktimep,
      minWidth: 200,
      flex: 1.2,
      valueGetter: (params) => {
        return `${params.row.period_name ? params.row.period_name : "-"}`;
      },
    },
  ];

  useEffect(() => {
    const rowsData = task.map((item, index) => ({
      ...item,
      rowNumber: index + 1,
      checkbox: selectAll,
    }));
    setRowData(rowsData);
  }, [task, selectAll]);

  useEffect(() => {
    dispatch(getUserListFromDb());
  }, []);

  const redirectModal = () => {
    navigate(-1);
  };
  return (
    <>
      <div className="">
        {/* <NavLink to={/edit-user}>callme</NavLink > */}
        <div className="mb-3 d-flex align-items-end justify-content-end">
          <Button
            variant="btn btn-warning"
            style={{
              width: "70px",
              height: "35px",
              fontSize: "14px",
              borderRadius: "20px",
              marginLeft: "10px",
            }}
            onClick={() => {
              redirectModal();
            }}
          >
            {translations[currentLanguage].back}
          </Button>
        </div>
        <div
          className="tableMenuHover"
          style={{ height: "85vh", width: "100%" }}
        >
          <PersistentDataGrid
            rows={rowData}
            columns={columns}
            getRowId={(params) => {
              return params.rowNumber;
            }}
            className="rounded"
            style={{
              fontFamily: "Poppins",
              padding: 5,
              backgroundColor: "white",
            }}
            pageSizeOptions={[5, 10, 25]}
            initialState={{
              ...task.initialState,
              pagination: { paginationModel: { pageSize: 50 } },
            }}
            components={{
              Toolbar: GridToolbar,
              NoRowsOverlay: () => (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <span>There is no Users with current branch</span>
                </div>
              ),
            }}
            componentsProps={{
              toolbar: {
                position: "right",
                style: { fontFamily: "Poppins", alignSelf: "end" },
              },
            }}
            rowSelection={false}
            autoPageSize={false}
          />
        </div>
      </div>
    </>
  );
}
